import { createRouteRef } from '@backstage/core-plugin-api';

export const entityPreviewRouteRef = createRouteRef({
  id: 'entity-preview.entity-preview',
});
